import request from "../utils/request";

export async function getIntegrations() {
  return request.get("integration/Integration/GetIntegrations");
}

export async function getIntegrationSettings(id) {
  return request.get(`integration/Integration/GetIntegrationSetting/${id}`);
}

export async function upsertIntegrationSettings(req) {
  return request.post("integration/Integration/UpsertIntegrationSettings", req);
}

export async function changeOrderStatus(req) {
  return request.put("integration/Integration/ChangeOrderStatus", req);
}

export async function getCancelReasons(integrationOrderId) {
  return request.get(
    "integration/Integration/CancelReasons?integrationOrderId=" +
      integrationOrderId
  );
}

export async function getOrders(params = {}) {
  return request.get("integration/Integration/GetOrders", { params });
}

export function dismissIntegrationOrderFromSelfServiceBoard(integrationOrderId) {
  return request.put(
    "integration/Integration/DismissFromBoardFromSelfService",
    { integrationOrderId }
  );
}

export function dismissAllCompletedFromSelfServiceBoard() {
  return request.put(
    "integration/Integration/DismissAllCompletedFromBoardFromSelfService"
  );
}

export async function getProducts(id, hardRefresh = false) {
  return request.get(`integration/Integration/${id}/Products`, {
    params: { hardRefresh },
  });
}

export async function getProductOptions(id, productId) {
  return request.get(
    `integration/Integration/${id}/ProductOptions/${productId}`
  );
}

export async function saveProduct(
  id,
  integrationProductId,
  productId,
  rawMaterialId
) {
  return request.post(
    `integration/Integration/${id}/SaveProduct?integrationProductId=${integrationProductId}` +
      (productId != null && productId > 0 ? `&productId=${productId}` : "") +
      (rawMaterialId != null && rawMaterialId > 0
        ? `&rawMaterialId=${rawMaterialId}`
        : "")
  );
}

export async function saveProductOption(
  id,
  integrationProductId,
  integrationProductOptionId,
  productExtraId,
  recipeStepId,
  rawMetarialId
) {
  return request.post(
    `integration/Integration/${id}/SaveProductOption?integrationProductId=${integrationProductId}&integrationProductOptionId=${integrationProductOptionId}&rawMetarialId=${rawMetarialId}` +
      (productExtraId != null ? `&productExtraId=${productExtraId}` : "") +
      (recipeStepId != null ? `&recipeStepId=${recipeStepId}` : "")
  );
}

export async function changeProductStatus(id, integrationProductId, status) {
  return request.put(
    `integration/Integration/${id}/ChangeProductStatus?integrationProductId=${integrationProductId}&status=${status}`
  );
}

export async function getOrdersManually() {
  return request.get(`integration/Integration/GetOrdersManually`);
}

export async function excelUpload(integrationId, data) {
  return request.post(
    `integration/Integration/${integrationId}/ExcelUpload`,
    data
  );
}
export async function generateExcel(integrationId) {
  return request.get(`integration/Integration/${integrationId}/GenerateExcel`);
}
